import React from 'react';
import { createRoot } from 'react-dom/client';
import { injectTheme } from './theme';
import App from './App';

injectTheme();
const el = document.getElementById('root');
if (el) createRoot(el).render(<React.StrictMode><App /></React.StrictMode>);
